<template>
    <div v-cloak>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("rangosHorarios")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="cambioNegocio()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.establishmentName">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <div class="card">

                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group">
                                <button @click="openModal(false)" class="btn btn-primary"><i
                                        class="fa fa-plus-square"></i>
                                    {{$t("nuevoRangoHorario")}}
                                </button>
                                <i class="fa fa-info-circle"></i>
                                <small>
                                    <router-link :to="{name:'ventas-negocios-zona-horaria'}">
                                        {{$t("verUnInformeDeRangosHorarios")}}
                                    </router-link>

                                </small>
                            </div>
                        </div>


                    </div>


                    <!--<div  class="form-group">
                        <label>Hora fin</label>
                        <datetime
                                :auto="true"
                                type="time"
                                class="theme-numier"
                                title="Hora fin"
                                :phrases="{ok: 'Aceptar', cancel: 'Salir'}"
                                input-class="form-control"
                                format="HH:mm"
                                v-model="hoursto"></datetime>
                    </div>-->

                    <div class="table-responsive" v-if="listRango.length>0 && respuesta">
                        <table class="table table-bordered table-striped">
                            <thead class="thead-dark">
                            <tr>
                                <th>{{$t("nombre")}}</th>
                                <th>{{$t("horaInicio")}}</th>
                                <th>{{$t("horaFin")}}</th>
                                <th width="10%">{{$t("acciones")}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="rango in listRango" :key="rango.id">
                                <td>
                                    <div>{{rango.name}}</div>
                                </td>
                                <td>
                                    <div v-if="rango.initHour">{{rango.initHour.substring(0,5)}}</div>
                                </td>
                                <td>
                                    <div v-if="rango.endHour">{{rango.endHour.substring(0,5)}}</div>
                                </td>
                                <td>
                                    <div>
                                        <a @click="getRangoHorario(rango.id)" class="btn btn-danger btn-link btn-xs">
                                            <i v-tooltip.top-center="$i18n.t('editar')" class="fas fa-pencil-alt"
                                               style="color: orange"></i>
                                        </a>
                                        <a @click="modalBorrarZonaHoraria(rango.id)"
                                           class="btn btn-danger btn-link btn-xs">
                                            <i v-tooltip.top-center="$i18n.t('borrarRangoHorario')"
                                               class="fas fa-trash-alt text-danger"></i>

                                        </a></div>

                                </td>

                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else class="alert alert-danger" role="alert">
                        {{$t("noHayRangosHorariosEnEsteNegocio")}}
                    </div>

                </div>
            </div>
        </div>

        <modal name="modal-nuevo-rango-horario" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{$t("rangosHorarios")}}</h4>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="nameHorario">{{$t("nombreRangosHorarios")}}</label>
                        <input type="text" class="form-control"
                               v-model="name"
                               id="nameHorario">
                    </div>


                    <div class="form-group">
                        <label>{{$t("horaInicio")}}</label>
                        <datetime
                                value-zone="Europe/Madrid"
                                :auto="true"
                                type="time"
                                class="theme-numier"
                                :title="$t('horaInicio')"
                                :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                input-class="form-control"
                                format="HH:mm"
                                v-model="hoursfrom"></datetime>
                    </div>
                    <div class="form-group">
                        <label>{{$t("horaFin")}}</label>
                        <datetime
                                value-zone="Europe/Madrid"
                                :auto="true"
                                type="time"
                                class="theme-numier"
                                :title="$t('horaFin')"
                                :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                input-class="form-control"
                                format="HH:mm"
                                v-model="hoursto"></datetime>
                    </div>
                </div>
                <div class="modal-footer">
                    <div align="right" class="col-12">

                        <button class="btn btn-danger" @click="closeModal()"><i class="fa fa-window-close"></i>
                            {{$t("cancelar")}}
                        </button>

                        <button class="btn btn-primary" @click="saveHorario()"><i class="fa fa-check-square"></i>
                            {{$t("guardar")}}
                        </button>

                    </div>
                </div>
            </div>
        </modal>

    </div>
</template>
<script>
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'
    import moment from 'moment'
    import { mapState } from 'vuex'

    export default {
        created() {
//            this.loading = Loading.service({text: 'Cargando...'});
            this.$store.dispatch("setNameRoute", this.$i18n.t("rangosHorarios"));
            this.getBusiness();

            if (this.$store.getters.idBusiness) {
                this.idBusiness = this.$store.getters.idBusiness;
            }
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                loading: false,
                listBusinesses: [],
                listRango: ["-"], // Pongo '-' para cuando cargue la vista no se vea el rojo de no hay elementos
                idBusiness: this.$route.params.idBusiness,
                searchQuery: this.$route.params.query,
                isSearch: false,
                pag: this.$route.params.pag,
                totalPags: 0,
                respuesta: true,

                hoursfrom: "00:00:00",
                hoursto: "23:59:59",
                name: "",

                idRangoHorario: null
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.params.pag) {
                    this.pag = to.params.pag;
                    this.getRangosHorarios();
                } else if (to.params.query) {
                    this.query = to.params.query;
                    this.getRangosHorarios();
                }
            }
        },
        computed: {
            ...mapState(["permiso"])
        },
        methods: {
            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {
                        if (!vm.idBusiness) {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.listBusinesses = response.data.result;
                        vm.getRangosHorarios();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            cambioNegocio() {

                this.pag = 1;
                this.totalPags = 0;

                this.getRangosHorarios();


            },
            getRangosHorarios() {

                const controller = 'getRangoHorario';
                var config = {
                    params: {
                        pag: this.pag,
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                this.$store.dispatch("setIdBusiness", this.idBusiness);

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "rangosHorarios/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listRango = response.data.result;


                            vm.respuesta = true;
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.respuesta = false;
                        }

//                        vm.loading.close();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getRangoHorario(id) {

                this.idRangoHorario = id;

                const controller = 'getRangoHorarioById';
                var config = {
                    params: {
                        pag: this.pag,
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                        idRangoHorario: id,

                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                this.$store.dispatch("setIdBusiness", this.idBusiness);

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "rangosHorarios/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.name = response.data.result.name;
                            vm.hoursfrom = response.data.result.initHour;
                            vm.hoursto = response.data.result.endHour;

                            vm.openModal(true);


                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.respuesta = false;
                        }

//                        vm.loading.close();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            saveHorario() {

                if (this.name === '') {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('elCampoNombreEsRequerido'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {
                    let fechaDesHours = moment(this.hoursfrom).format("HH:mm:ss");
                    let fechaHastHours = moment(this.hoursto).format("HH:mm:ss");


                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idBusiness: this.idBusiness,
                        hoursfrom: fechaDesHours,
                        jwt: this.$store.getters.jwt,
                        hoursto: fechaHastHours,
                        name: this.name,
                        idRangoHorario: this.idRangoHorario
                    };


                    let vm = this;
                    let controller = this.idRangoHorario ? "editRangoHorarios" : "newRangoHorarios";
                    this.axios.post(this.$store.getters.apiUrl + 'rangosHorarios/' + controller, params, config)
                        .then(function (response) {

                            if (response.data.response) {
                                let notify = vm.idRangoHorario ? vm.$t("actualizada") : vm.$t("creada");
                                vm.$notify({
                                    message: vm.$t('rangoHorario') + notify + ' '+ vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                vm.getRangosHorarios();

                                vm.$modal.hide("modal-nuevo-rango-horario");


                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });

                    this.idRangoHorario = null;
                    this.name = "";
                    this.hoursfrom = "00:00:00";
                    this.hoursto = "23:59:59";

                }


            },

            closeModal() {

                this.$modal.hide("modal-nuevo-rango-horario");
                this.idRangoHorario = null;
                this.name = "";
                this.hoursfrom = "00:00:00";
                this.hoursto = "23:59:00";
            },

            openModal(editar) {
                if (editar) {

                    this.$modal.show("modal-nuevo-rango-horario");
                } else {

                    if (this.listRango.length < 12) {
                        this.$modal.show("modal-nuevo-rango-horario");
                    } else {
                        swal({
                            title: this.$t('soloPuedeCrearUnMaximoDeXRangosHorarios'),
                            type: 'info',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            confirmButtonText: this.$t('deAcuerdo'),
                            buttonsStyling: true
                        });
                    }

                }
            },

            deleteZonaHoraria(id) {

                var params = {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    id: id
                };

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                let controller = "deleteRangoHorario";
                this.axios.post(this.$store.getters.apiUrl + 'rangosHorarios/' + controller, params, config)
                    .then(function (response) {

                        if (response.data.response) {
                            vm.$notify({
                                message: vm.$t('rangoHorario') + vm.$t('eliminado') + ' '+vm.$t('correctamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                            vm.getRangosHorarios();

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });

            },

            modalBorrarZonaHoraria(id) {

                swal({
                    title: this.$t('deseaEliminarEsteRangoHorario'),
                    text: this.$t('estaOperacionNoSePuedeDeshacer'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    confirmButtonText: this.$t('siBorrarRangoHorario'),
                    cancelButtonText: this.$t('cancelar'),
                    buttonsStyling: true
                }).then((result) => {
                    if (result.value) {

                        this.deleteZonaHoraria(id);

                    }
                });

            }

        }

    }
</script>

<style scoped>

    [v-cloak] {
        display: none;
    }

    tbody tr:hover {
        background-color: rgba(0, 153, 130, 0.2);
    }

    tbody td {
        padding: 0 !important;
    }

    td div {
        padding: 12px 8px;
        color: #333;
    }

    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }

    .card {
        padding: 20px;
    }

    .input-group button {
        height: 40px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/General/RangosHorarios.vue